<app-checkmark-loader [loading]="loading" class="apply__checkmark"></app-checkmark-loader>

<div class="apply__send" i18n>Votre candidature a été envoyée&nbsp;!</div>

<a class="apply__back btn" [routerLink]="['/', featuresRoutingEnum.Job, jobId]" i18n>Retour</a>
